import type { RegistrationSource } from '@creativitas/shared';

/**
 * Метки ссылки (`utm_source`, `utm_medium`, `utm_campaign`), по которой
 * человек пришёл, — для источника регистрации (docs/ANALYTICS.md).
 *
 * По ссылке из рассылки или с сайта человек может попасть на любую страницу,
 * походить по ней и только потом нажать «Зарегистрироваться» — адрес к этому
 * времени меток уже не содержит. Поэтому они запоминаются при открытии
 * приложения и живут, пока открыта вкладка (`sessionStorage`). Новая ссылка с
 * метками заменяет прежние; ссылка без меток их не стирает.
 *
 * Сервер проверяет метки сам и отбрасывает лишнее: здесь только сбор.
 */

const KEY = 'creativitas:utm';
const PARAMS = { utmSource: 'utm_source', utmMedium: 'utm_medium', utmCampaign: 'utm_campaign' } as const;

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function captureUtm(search: string = window.location.search): void {
  const params = new URLSearchParams(search);
  const found: RegistrationSource = {};
  for (const [field, param] of Object.entries(PARAMS) as [keyof RegistrationSource, string][]) {
    const value = params.get(param)?.trim();
    if (value) found[field] = value.slice(0, 100);
  }
  if (Object.keys(found).length === 0) return;
  try {
    storage()?.setItem(KEY, JSON.stringify(found));
  } catch {
    /* Запрет хранить данные — значит, источник просто не узнаем. */
  }
}

export function storedUtm(): RegistrationSource | undefined {
  try {
    const raw = storage()?.getItem(KEY);
    if (!raw) return undefined;
    const value = JSON.parse(raw) as Record<string, unknown>;
    const result: RegistrationSource = {};
    for (const field of Object.keys(PARAMS) as (keyof RegistrationSource)[]) {
      if (typeof value[field] === 'string') result[field] = value[field] as string;
    }
    return Object.keys(result).length > 0 ? result : undefined;
  } catch {
    return undefined;
  }
}
